import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/importacaoprojeto', { params: parametros }).then(response => response.data);
  },
  listaExcel: filtros => {
    return Vue.http.get('/api/importacaoprojeto/excel', { params: filtros, responseType: 'blob' })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/importacao-projeto/servico.js